export enum MailboxOwnerType {
    CITIZEN = 'CITIZEN',
    ORGANISATION = 'ORGANISATION',
}

export enum MailboxAccessType {
    OWNER = 'OWNER',
    PARTY_REPRESENTATIVE = 'PARTY_REPRESENTATIVE',
    FULL_POWER_OF_ATTORNEY = 'FULL_POWER_OF_ATTORNEY',
    MESSAGE_WRITE = 'MESSAGE_WRITE',
}
